export const connectOptions = [
  { value: '1', label: '且' },
  { value: '0', label: '或' },
]

export const conditionList = [
  { value: '=', label: '等于=', includes: ['text', 'number', 'date', 'boolean'] },
  { value: '<>', label: '不等于<>', includes: ['text', 'number', 'date', 'boolean'] },
  { value: '<', label: '小于<', includes: ['number', 'date'] },
  { value: '<=', label: '小于等于<=', includes: ['number', 'date'] },
  { value: '>', label: '大于>', includes: ['number', 'date'] },
  { value: '>=', label: '大于等于>=', includes: ['number', 'date'] },
  // {value: 'BETWEEN', label: '介于 between', includes: ['number', 'date']},
  // {value: 'NOT BETWEEN', label: '不介于 not between', includes: ['number', 'date']},
  { value: 'IS NULL', label: '为空 is null', includes: ['text', 'number', 'date', 'boolean', 'fk'] },
  { value: 'IS NOT NULL', label: '非空 not null', includes: ['text', 'number', 'date', 'boolean', 'fk'] },
  { value: 'IN LIST', label: '属于 in', includes: ['text'] },
  // {value: 'NOT IN', label: '不属于 not in', includes: ['text']},
  { value: 'LIKE', label: '匹配 like', includes: ['text'] },
  // {value: 'NOT LIKE', label: '不匹配 not like', includes: ['text']},
  { value: 'STARTS WITH', label: '开头是 starts with', includes: ['text'] },
  // {value: 'NOT STARTS WITH', label: '开头不是 not starts with', includes: ['text']},
  { value: 'ENDS WITH', label: '结尾是 ends with', includes: ['text'] },
  // {value: 'NOT ENDS WITH', label: '结尾不是 not end with', includes: ['text']}
]

export const romaConditionList = [
  { value: 'equal', label: '等于=' },
  { value: 'notEqual', label: '不等于<>' },
  { value: 'less', label: '小于<' },
  { value: 'lessEqual', label: '小于等于<=' },
  { value: 'more', label: '大于>' },
  { value: 'moreEqual', label: '大于等于>=' },
  { value: 'isNull', label: '为空 is null' },
  { value: 'notNull', label: '非空 not null' },
  { value: 'isEmpty', label: 'isEmpty' },
  { value: 'notEmpty', label: 'notEmpty' },
  { value: 'between', label: '介于 between' },
  { value: 'notBetween', label: '不介于 not between' },
  { value: 'inList', label: '属于 in' },
  { value: 'notInList', label: '不属于 not in' },
]

export const filterGroupData = {
  negated: 'N',
  operator: '1',
  childConditions: [],
}

export const filterItemData = {
  negated: 'N',
  letfFilterField: '',
  structWid: '',
  operator: '1',
  compareType: '',
  between: ['', ''],
  rightFilterField: '',
  showRightField: '',
  rightFilterValue: {
    filterValueArr: [],
    filterType: '',
    filterValue: '',
    convertFormat: '',
    length: '',
    precision: '',
  },
}

export const createFilterGroupItem = () => {
  return { ...filterGroupData, childConditions: [JSON.parse(JSON.stringify(filterItemData))] }
}
